export const STATUS_WORKING = 1;
export const STATUS_PAUSED = 2;

export const ACCOUNT_ACTIVE = 1;
export const ACCOUNT_PAUSED = 2;

// app/Account/constants.ts

export const languages = [
  { value: 'af', name: 'Afrikaans', direction: 'ltr', countryCode: 'za' },
  { value: 'sq', name: 'Albanian', direction: 'ltr', countryCode: 'al' },
  { value: 'am', name: 'Amharic', direction: 'ltr', countryCode: 'et' },
  { value: 'ar', name: 'Arabic', direction: 'rtl', countryCode: 'sa' },
  { value: 'hy', name: 'Armenian', direction: 'ltr', countryCode: 'am' },
  { value: 'as', name: 'Assamese', direction: 'ltr', countryCode: 'in' },
  { value: 'az', name: 'Azeri', direction: 'ltr', countryCode: 'az' }, // Career app says RTL in one place, LTR in list. Defaulting to LTR for Azeri (Latin)
  { value: 'eu', name: 'Basque', direction: 'ltr', countryCode: 'es' },
  { value: 'be', name: 'Belarusian', direction: 'ltr', countryCode: 'by' },
  { value: 'bn', name: 'Bengali', direction: 'ltr', countryCode: 'bd' },
  { value: 'bs', name: 'Bosnian', direction: 'ltr', countryCode: 'ba' },
  { value: 'bg', name: 'Bulgarian', direction: 'ltr', countryCode: 'bg' },
  { value: 'my', name: 'Burmese', direction: 'ltr', countryCode: 'mm' },
  { value: 'ca', name: 'Catalan', direction: 'ltr', countryCode: 'ad' },
  { value: 'zh', name: 'Chinese', direction: 'ltr', countryCode: 'cn' },
  { value: 'hr', name: 'Croatian', direction: 'ltr', countryCode: 'hr' },
  { value: 'cs', name: 'Czech', direction: 'ltr', countryCode: 'cz' },
  { value: 'da', name: 'Danish', direction: 'ltr', countryCode: 'dk' },
  { value: 'Dhivehi', name: 'Divehi', direction: 'rtl', countryCode: 'mv' },
  { value: 'nl', name: 'Dutch', direction: 'ltr', countryCode: 'nl' },
  { value: 'en', name: 'English', direction: 'ltr', countryCode: 'gb' },
  { value: 'et', name: 'Estonian', direction: 'ltr', countryCode: 'ee' },
  { value: 'mk', name: 'FYRO Macedonia', direction: 'ltr', countryCode: 'mk' },
  { value: 'fo', name: 'Faroese', direction: 'ltr', countryCode: 'fo' },
  { value: 'fa', name: 'Farsi - Persian', direction: 'rtl', countryCode: 'ir' },
  { value: 'fi', name: 'Finnish', direction: 'ltr', countryCode: 'fi' },
  { value: 'fr', name: 'French', direction: 'ltr', countryCode: 'fr' },
  { value: 'gd', name: 'Gaelic', direction: 'ltr', countryCode: 'gb' },
  { value: 'gl', name: 'Galician', direction: 'ltr', countryCode: 'es' },
  { value: 'ka', name: 'Georgian', direction: 'ltr', countryCode: 'ge' },
  { value: 'de', name: 'German', direction: 'ltr', countryCode: 'de' },
  { value: 'el', name: 'Greek', direction: 'ltr', countryCode: 'gr' },
  { value: 'gn', name: 'Guarani - Paraguay', direction: 'ltr', countryCode: 'py' },
  { value: 'gu', name: 'Gujarati', direction: 'ltr', countryCode: 'in' },
  { value: 'he', name: 'Hebrew', direction: 'rtl', countryCode: 'il' },
  { value: 'hi', name: 'Hindi', direction: 'ltr', countryCode: 'in' },
  { value: 'hu', name: 'Hungarian', direction: 'ltr', countryCode: 'hu' },
  { value: 'is', name: 'Icelandic', direction: 'ltr', countryCode: 'is' },
  { value: 'id', name: 'Indonesian', direction: 'ltr', countryCode: 'id' },
  { value: 'it', name: 'Italian', direction: 'ltr', countryCode: 'it' },
  { value: 'ja', name: 'Japanese', direction: 'ltr', countryCode: 'jp' },
  { value: 'kn', name: 'Kannada', direction: 'ltr', countryCode: 'in' },
  { value: 'ks', name: 'Kashmiri', direction: 'rtl', countryCode: 'in' },
  { value: 'kk', name: 'Kazakh', direction: 'ltr', countryCode: 'kz' },
  { value: 'km', name: 'Khmer', direction: 'ltr', countryCode: 'kh' },
  { value: 'ko', name: 'Korean', direction: 'ltr', countryCode: 'kr' },
  { value: 'lo', name: 'Lao', direction: 'ltr', countryCode: 'la' },
  { value: 'la', name: 'Latin', direction: 'ltr', countryCode: 'va' },
  { value: 'lv', name: 'Latvian', direction: 'ltr', countryCode: 'lv' },
  { value: 'lt', name: 'Lithuanian', direction: 'ltr', countryCode: 'lt' },
  { value: 'ms', name: 'Malay', direction: 'ltr', countryCode: 'my' },
  { value: 'ml', name: 'Malayalam', direction: 'ltr', countryCode: 'in' },
  { value: 'mt', name: 'Maltese', direction: 'ltr', countryCode: 'mt' },
  { value: 'mi', name: 'Maori', direction: 'ltr', countryCode: 'nz' },
  { value: 'mr', name: 'Marathi', direction: 'ltr', countryCode: 'in' },
  { value: 'mn', name: 'Mongolian', direction: 'ltr', countryCode: 'mn' },
  { value: 'ne', name: 'Nepali', direction: 'ltr', countryCode: 'np' },
  { value: 'nb', name: 'Norwegian - Bokml', direction: 'ltr', countryCode: 'no' },
  { value: 'nn', name: 'Norwegian - Nynorsk', direction: 'ltr', countryCode: 'no' },
  { value: 'or', name: 'Oriya', direction: 'ltr', countryCode: 'in' },
  { value: 'pl', name: 'Polish', direction: 'ltr', countryCode: 'pl' },
  { value: 'pt', name: 'Portuguese', direction: 'ltr', countryCode: 'pt' },
  { value: 'pa', name: 'Punjabi', direction: 'ltr', countryCode: 'in' },
  { value: 'rm', name: 'Raeto-Romance', direction: 'ltr', countryCode: 'ch' }, // Assuming Swiss Romansh
  { value: 'ro', name: 'Romanian', direction: 'ltr', countryCode: 'ro' },
  { value: 'ru', name: 'Russian', direction: 'ltr', countryCode: 'ru' },
  { value: 'sa', name: 'Sanskrit', direction: 'ltr', countryCode: 'in' },
  { value: 'sr', name: 'Serbian', direction: 'ltr', countryCode: 'rs' },
  { value: 'tn', name: 'Setsuana', direction: 'ltr', countryCode: 'bw' },
  { value: 'sd', name: 'Sindhi', direction: 'ltr', countryCode: 'pk' },
  { value: 'si', name: 'Sinhala', direction: 'ltr', countryCode: 'lk' },
  { value: 'sk', name: 'Slovak', direction: 'ltr', countryCode: 'sk' },
  { value: 'sl', name: 'Slovenian', direction: 'ltr', countryCode: 'si' },
  { value: 'so', name: 'Somali', direction: 'ltr', countryCode: 'so' },
  { value: 'sb', name: 'Sorbian', direction: 'ltr', countryCode: 'de' }, // Assuming Lower Sorbian/Germany
  { value: 'es', name: 'Spanish', direction: 'ltr', countryCode: 'es' },
  { value: 'sw', name: 'Swahili', direction: 'ltr', countryCode: 'tz' },
  { value: 'sv', name: 'Swedish', direction: 'ltr', countryCode: 'se' },
  { value: 'tg', name: 'Tajik', direction: 'ltr', countryCode: 'tj' },
  { value: 'ta', name: 'Tamil', direction: 'ltr', countryCode: 'in' },
  { value: 'tt', name: 'Tatar', direction: 'ltr', countryCode: 'ru' },
  { value: 'te', name: 'Telugu', direction: 'ltr', countryCode: 'in' },
  { value: 'th', name: 'Thai', direction: 'ltr', countryCode: 'th' },
  { value: 'bo', name: 'Tibetan', direction: 'ltr', countryCode: 'cn' }, // Or bt/np
  { value: 'ts', name: 'Tsonga', direction: 'ltr', countryCode: 'za' },
  { value: 'tr', name: 'Turkish', direction: 'ltr', countryCode: 'tr' },
  { value: 'tk', name: 'Turkmen', direction: 'ltr', countryCode: 'tm' },
  { value: 'uk', name: 'Ukrainian', direction: 'ltr', countryCode: 'ua' },
  { value: 'ur', name: 'Urdu', direction: 'rtl', countryCode: 'pk' },
  { value: 'uz', name: 'Uzbek', direction: 'ltr', countryCode: 'uz' },
  { value: 'vi', name: 'Vietnamese', direction: 'ltr', countryCode: 'vn' },
  { value: 'cy', name: 'Welsh', direction: 'ltr', countryCode: 'gb' },
  { value: 'xh', name: 'Xhosa', direction: 'ltr', countryCode: 'za' },
  { value: 'yi', name: 'Yiddish', direction: 'rtl', countryCode: 'il' },
  { value: 'zu', name: 'Zulu', direction: 'ltr', countryCode: 'za' }
];

export const SET_NUMBER_OF_TEAM_MEMBERS = 'app/Account/SET_NUMBER_OF_TEAM_MEMBERS';
export const SET_ACCOUNT_STATS = 'app/Account/SET_ACCOUNT_STATS';
export const SET_LOADING = 'app/Account/SET_LOADING';

export const ACTIVATE_ACCOUNT = 'app/Account/ACTIVATE_ACCOUNT';
export const PATCH_STATUS = 'app/Account/PATCH_STATUS';
export const UPDATE_STATUS = 'app/Account/UPDATE_STATUS';

export const PATCH_USER_STATUS = 'app/Account/PATCH_USER_STATUS';
export const CANCEL_PATCH_USER_STATUS = 'app/Account/CANCEL_PATCH_USER_STATUS';
export const START_EDIT_USER = 'app/Account/START_EDIT_USER';
export const FINISH_EDIT_USER = 'app/Account/FINISH_EDIT_USER';
export const PATCH_USER = 'app/Account/PATCH_USER';
export const START_CHANGE_USER_PASSWORD = 'app/Account/MyProfile/START_CHANGE_PASSWORD';
export const CANCEL_CHANGE_USER_PASSWORD = 'app/Account/MyProfile/CANCEL_CHANGE_PASSWORD';
export const CHANGE_USER_PASSWORD = 'app/Account/MyProfile/CHANGE_USER_PASSWORD';

export const PAUSE_LAST_ADMIN_DIALOG = 'app/Account/MyProfile/PAUSE_LAST_ADMIN_DIALOG';

